import { createContext } from 'react';

import type { AuthContextProps } from './AuthContextTypes';

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
